config.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'TkrConfig'];
export function config($locationProvider, $stateProvider, $urlRouterProvider, TkrConfig) {
    $urlRouterProvider.otherwise('/');
    $stateProvider
        .state('idx', {
        url: '/',
        templateUrl: TkrConfig.aUrl('tiet/tielista.html')
    });
}
